import React from "react";

const CarRentalServices = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}

<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Car Rental Services</h1>
          </div>
        </div>
      </section>

    

      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/04.jpeg"
                alt="Car Rental Services in Pune"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Car</span> Rental Services in Pune
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. provides reliable and
                professional chauffeur-driven car rental services for
                corporate, business, and personal travel needs.
              </p>

              <p>
                Our services are designed to meet the expectations of
                multinational companies, IT firms, executives, and
                professionals who value punctuality, comfort, and safety.
              </p>

              <p>
                Whether it’s daily office commute, airport transfers,
                client meetings, or long-term corporate contracts, we
                ensure seamless mobility with our premium fleet and
                trained chauffeurs.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US – FULL WIDTH SECTION ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Pune Corporate Cars?</h2>
              <p className="text-muted">
                Trusted by leading corporates for consistent service,
                transparency, and operational excellence.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Well-maintained premium fleet</li>
                <li className="mb-3">✔ Uniformed & background-verified chauffeurs</li>
                <li className="mb-3">✔ Flexible monthly & long-term contracts</li>
                <li className="mb-3">✔ Corporate billing with MIS & reporting</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ 24×7 operations & customer support</li>
                <li className="mb-3">✔ Airport, local & outstation services</li>
                <li className="mb-3">✔ Strong focus on safety & compliance</li>
                <li className="mb-3">✔ Dedicated corporate account management</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default CarRentalServices;
